import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import "./FilterPanel.scss";
import HelpFilterArrow from "../../../../assets/VZY/HelpFilter.svg";
export const HelpFilter = ({ title, onApplyFilters, filterIds }) => {
  const apiBaseURL = process.env.REACT_APP_API_URL || window.location.origin;
  const [filterOption, setFilterOptions] = useState([]);
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const toggleOption = (item) => {
    setSelected((prev) =>
      prev.some((i) => i.categoryID === item?.categoryID)
        ? prev.filter((i) => i.categoryID !== item?.categoryID)
        : [...prev, item],
    );
  };

  const removeItem = (id) => {
    const updated = selected.filter((i) => i.categoryID !== id);
    setSelected(updated);
    onApplyFilters(updated.map((i) => i.categoryID));
  };

  const resetFilters = () => setSelected([]);

  const fetchFilterList = useCallback(async () => {
    const payload = {
      ContentTypeID: Number(filterIds),
    };
    try {
      const response = await axios.post(
        `${apiBaseURL}/api/VZYHelpSupport/FetchFilterCategory`,
        payload,
        { headers: { "Content-Type": "application/json" } },
      );

      setFilterOptions(response?.data?.result?.filterCategories ?? []);
    } catch (err) {
      console.error("FetchFilterCategory error:", err);
    }
  }, []);

  useEffect(() => {
    fetchFilterList();
  }, [fetchFilterList]);

  useEffect(() => {
    if (open) {
      document.body.classList.add("filter-no-scroll");
    } else {
      document.body.classList.remove("filter-no-scroll");
    }
    return () => {
      document.body.classList.remove("filter-no-scroll");
    };
  }, [open]);
  return (
    <>
      <div className="title-filter-row">
        <h4 className="detail-page-title">{title}</h4>
        <div className="filter-wrapper">
          <button
            className="filter-btn"
            onClick={() => setOpen((prev) => !prev)}
            aria-expanded={open}
          >
            <img src={HelpFilterArrow} alt="Filters" />
            Filters
          </button>

          {open && (
            <div className={`filter-panel ${open ? "filter-expanted" : ""}`}>
              <ul>
                {filterOption.map((item) => {
                  const isChecked = selected.some(
                    (i) => i.categoryID === item.categoryID,
                  );

                  return (
                    <li
                      key={item.categoryID}
                      onClick={() => toggleOption(item)}
                    >
                      <input type="checkbox" checked={isChecked} readOnly />
                      <span>{item?.categoryName}</span>
                    </li>
                  );
                })}
              </ul>

              <div className="filter-footer">
                <button
                  className="apply-btn"
                  onClick={() => {
                    onApplyFilters(selected.map((i) => i.categoryID));
                    setOpen(false);
                  }}
                >
                  Apply
                </button>

                <button
                  className="reset-btn"
                  onClick={() => {
                    resetFilters();
                    onApplyFilters([]);
                  }}
                >
                  Reset Filters
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      {selected.length > 0 && (
        <div className="selected-filters">
          {selected.map((item) => (
            <span className="filter-chip" key={item.categoryID}>
              {item.categoryName}
              <span
                title="Remove"
                className="chip-close"
                onClick={() => removeItem(item.categoryID)}
                aria-label={`Remove ${item.categoryName}`}
              >
                ×
              </span>
            </span>
          ))}
        </div>
      )}
    </>
  );
};
